import React, { Component, createRef } from 'react';
import { Tooltip } from '@mui/material';
import { TipTapEditor } from '../../../../TipTap';

/**
 * Autocomplete - Table cell editor with function and placeholder support
 * 
 * No toolbar, outputs plain text, supports = (functions) and $ (placeholders).
 * Used in table cells for formula-like inputs.
 */
class Autocomplete extends Component {
  editorRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      content: this.normalizeContent(this.props.text),
    };
  }

  normalizeContent(text) {
    let content = text;
    if (content) {
      content = content.toString();
      content = content.replace(/(?:\r\n|\r|\n\n)/g, '<br>');
      content = content.replace(/(?:\n)/g, '');
    } else {
      content = '';
    }
    return content;
  }

  componentDidMount() {
    this.setState({
      content: this.normalizeContent(this.props.text),
    });
  }

  handleFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  handleChange = (value) => {
    this.setState({ content: value });
  };

  handleBlur = (value) => {
    // Clean up the value
    let cleanValue = value;
    cleanValue = cleanValue.replaceAll('&nbsp;', ' ');

    if (this.props.onChange) {
      this.props.onChange(cleanValue);
    }
  };

  // Combine function placeholders and regular placeholders
  getCombinedPlaceholders = () => {
    const { functions, availablePlaceholders } = this.props;
    const combined = [];
    
    // Add function placeholders (for = trigger)
    if (functions && functions.length > 0 && functions[0].placeholders) {
      combined.push(...functions[0].placeholders);
    }
    
    // Add regular placeholders (for $ trigger)
    if (availablePlaceholders) {
      const placeholdersList = availablePlaceholders[0]?.placeholders || availablePlaceholders;
      combined.push(...placeholdersList);
    }
    
    return combined;
  };

  render() {
    const { error, helperText, style, className, availablePlaceholders } = this.props;
    const { content } = this.state;

    const tooltipText = availablePlaceholders == null
      ? 'Type "={" to insert a function'
      : 'Type "${" or "={" for commands';

    return (
      <Tooltip
        placement="bottom"
        title={tooltipText}
        enterDelay={1200}
        enterNextDelay={1200}
      >
        <div onClick={this.handleFocus} style={style} className={className}>
          <TipTapEditor
            ref={this.editorRef}
            value={content}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            showToolbar={false}
            stripHtml={true}
            triggerChars={['=', '$']}
            availablePlaceholders={this.getCombinedPlaceholders()}
            variant="minimal"
            error={error}
            helperText={helperText}
          />
        </div>
      </Tooltip>
    );
  }
}

export default Autocomplete;
